import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'



export default class Gatekeeper extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            clicked: false,
            ready: false
        }
    }


    componentDidMount() {
        const { id } = this.props

        window.addEventListener('scroll', this.isScrolled)

        const script = document.createElement('script');
        script.src = `https://dol-sensors67660.activehosted.com/f/embed.php?id=${id}`
        script.async = true
        script.setAttribute('id', 'activecampaign-script')
        document.body.appendChild(script)
        let formElement = document.getElementById("form-container");
        formElement.addEventListener("change", null);
        const observer = new MutationObserver(() => {
            this.formLoader(this.props.id);
        })
        observer.observe(formElement, {
            childList: true
        })

    }


    formChange = (a) => {
      if(this.props.parentCallback){
        this.props.parentCallback(a)
      }
    }

    formLoader = (formId) => {
        let form = document.getElementById('form-container').querySelector('._form_'+formId)
        document.getElementById('_form_' + this.props.id + '_submit').addEventListener("click", function () {
            if (form.querySelector('#fullname').value !== "") {
                localStorage.setItem('name', form.querySelector('#fullname').value);
                localStorage.setItem('email', form.querySelector('#email').value);
                localStorage.setItem('formId', formId);
            }
            form.requestSubmit()
        });
        this.setState({ready: true}, this.formChange(true))
        
    }

    render() {
        const {
            bodyText,
            id
        } = this.props

        return (
            <Wrapper>
                    <Form className={`_form_${id}`} id="form-container" >
                    </Form>
            </Wrapper>
        )
    }
}

// Styles


const Wrapper = styled.div`
`
const Form = styled.div`
&&#form-container {
    * {
      font-family: "Work Sans";
      color: black;
      font-size: 16px;
    }

    ._form-content{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    ._field1, ._x29757849 {
      display: none;
    }

    #field[1]{
      display: none !important;
    }

    ._x06147226 {
      width: 40%;
      flex-grow: 2;
    }

    ._x74459413 {
      width: 40%;
      flex-grow: 2;
      margin-left: 5%;
    }

    ._field32 {
      width: 40%
      flex-grow: 2;
    }

    
    ._field32 option {
      width: 80%;
    } 

    ._field57 {
      width: 40%;
      flex-grow: 2;
      margin-left: 5%;
    }

    ._field57 option {
      width: 80%;
    }

    textarea {
      background: white;
      color: #000033 !important;
      transition: all 0.2s !important;
    }

    textarea:focus {
      height: 8em !important;
    }

    form {
      width: 100%;
      margin: 0;
      padding: 0;
      background: none !important;
    }

    p {
      font-size: 16px !important;
    }

    ._form-title {
      font-weight: 300;
      font-size: 30px;
      line-height: 45px;
    }

    ._form-label {
      font-weight: 500;
    }

    ._form_element {
      margin-bottom: 1.5em;
    }
    
    ._field-wrapper {
      select,
      input {
        background: white;
        color: #000033 !important;
        border: none;
        border-radius: 0;
        padding: 1em 0.5em;

        &::placeholder {
          color: #000033;
        }
      }
    }

    ._submit {
      background: #00994c !important;
      text-transform: uppercase;
      border-radius: 2em !important;
      padding: 0.5em 1.5em !important;
      transition: all .2s ease-in-out !important;
    }

    ._submit:hover {
      background: #00994cad !important;
    }

    .disabled {
      background-color: grey !important;
    }

    .disabled:hover{
      background-color: grey !important;
    }

    ._form-branding {
      display: none;
    }

    ._form-fieldset > div > span {
      color: red !important;
    }

  }
`


// WEBPACK FOOTER //
// ./src/ui/components/Form.js